import React from 'react';

import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from '@modules/shared/pagination';
import { HOME_ROUTES } from '@util/constants';

type Props = {
  page: number;
  totalPages: number;
  selectedCategory?: string;
};

export const NewNavigation = (props: Props) => {
  const { page, totalPages, selectedCategory } = props;

  return (
    <div className="mt-8 not-prose">
      <Pagination>
        <PaginationContent>
          <PaginationItem>
            <PaginationPrevious
              className={page === 1 ? 'pointer-events-none text-muted' : ''}
              href={`${HOME_ROUTES.BLOG}?page=${Math.max(page - 1, 1)}${
                selectedCategory ? `&category=${selectedCategory}` : ''
              }`}
            />
          </PaginationItem>
          <PaginationItem>
            <PaginationLink href={`${HOME_ROUTES.BLOG}?page=${page}`}>
              {page}
            </PaginationLink>
            <PaginationLink href={`${HOME_ROUTES.BLOG}?page=${totalPages}`}>
              ...{totalPages}
            </PaginationLink>
          </PaginationItem>
          <PaginationItem>
            <PaginationNext
              className={
                page === totalPages ? 'pointer-events-none text-muted' : ''
              }
              href={`${HOME_ROUTES.BLOG}?page=${Math.min(
                page + 1,
                totalPages,
              )}${selectedCategory ? `&category=${selectedCategory}` : ''}`}
            />
          </PaginationItem>
        </PaginationContent>
      </Pagination>
    </div>
  );
};
